export default __webpack_public_path__ + "static/media/logo.254bccf6.png";